"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreetviewService = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const index_1 = require("./index");
const PANORAMA_OPTIONS = {
    addressControl: false,
    fullscreenControl: false
};
class StreetviewService {
    constructor() {
        this.__priority = 100;
        this.callbackQueue = [];
        this.isReady = false;
    }
    init() {
        const waitForGoogleMaps = index_1.Services.Window.window.setInterval(() => {
            if (typeof google === 'undefined') {
                return;
            }
            index_1.Services.Window.window.clearTimeout(waitForGoogleMaps);
            this.setIsReady();
            this.callbackQueue.forEach(callback => {
                callback(this.instance);
            });
        }, 10);
    }
    /**
     * Fetch Google Map instance, reusing existing instance to avoid impacting Google Maps API quota.
     */
    get instance() {
        if (!this.isReady) {
            throw new Error('Cannot fetch map before Google Maps API loaded');
        }
        if (this.streetviewInstance == null) {
            this.streetviewEl = index_1.Services.Window.document.createElement('div');
            this.streetviewEl.style.width = '100%';
            this.streetviewEl.style.height = '100%';
            this.streetviewInstance = new google.maps.StreetViewPanorama(this.streetviewEl, this.streetviewOptions);
        }
        return this.streetviewInstance;
    }
    /**
     * Fetch StreetViewService instance, initializing it if necessary.
     */
    get streetViewService() {
        if (!this.streetviewServiceInstance) {
            this.streetviewServiceInstance = new google.maps.StreetViewService();
        }
        return this.streetviewServiceInstance;
    }
    attach(el) {
        const instance = this.instance;
        if (!instance) {
            return null;
        }
        el.appendChild(this.streetviewEl);
        return instance;
    }
    onReady(callback) {
        this.callbackQueue.push(callback);
    }
    setPanoramaOptions(options, patch = false) {
        if (patch) {
            this.streetviewOptions = Object.assign(Object.assign(Object.assign({}, PANORAMA_OPTIONS), this.streetviewOptions), options);
        }
        else {
            this.streetviewOptions = Object.assign(Object.assign({}, PANORAMA_OPTIONS), options);
        }
    }
    setIsReady() {
        this.isReady = true;
    }
}
exports.StreetviewService = StreetviewService;
tslib_1.__decorate([
    mobx_1.observable
], StreetviewService.prototype, "isReady", void 0);
tslib_1.__decorate([
    mobx_1.observable
], StreetviewService.prototype, "streetviewOptions", void 0);
tslib_1.__decorate([
    mobx_1.action
], StreetviewService.prototype, "setPanoramaOptions", null);
tslib_1.__decorate([
    mobx_1.action
], StreetviewService.prototype, "setIsReady", null);
//# sourceMappingURL=streetview.service.js.map